<template>
  <div>
    <!-- Header: Personal Info -->
    <div class="d-flex">
      <feather-icon
        icon="UserIcon"
        size="19"
      />
      <h4
        class="mb-0 ml-50"
      >
        Personal Information
      </h4>
    </div>
    <profile-picture />
    <!-- Form: Personal Info Form -->
    <validation-observer ref="personalInfoValidation">
      <b-form
        autocomplete="off"
        class="mt-1"
      >
        <b-row>
          <!-- Field: First Name -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="First Name"
              label-for="first-name"
            >
              <validation-provider
                #default="{ errors }"
                name="First Name"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="first-name"
                    v-model="driverInfo.firstName"
                    @keydown="validateName"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Last Name -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Last Name"
              label-for="last-name"
            >
              <validation-provider
                #default="{ errors }"
                name="Last Name"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="last-name"
                    v-model="driverInfo.lastName"
                    @keypress="validateName"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Email -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Email"
              label-for="email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="email"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="email"
                    v-model="driverInfo.email"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <!-- Field: National ID -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="National ID"
              label-for="national-id"
            >
              <validation-provider
                #default="{ errors }"
                name="National ID"
                rules="required|max:15"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="national-id"
                    v-model="driverInfo.nationalId"
                    @keypress="maxCharacters($event, 15)"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Gender"
              label-for="gender"
              label-class="mb-1"
            >
              <validation-provider
                #default="{ errors }"
                name="Gender"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-radio-group
                    id="gender"
                    v-model="driverInfo.gender"
                    :options="genderOptions"
                    value="male"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <!-- Field: Address -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="City"
              label-for="city"
            >
              <validation-provider
                #default="{ errors }"
                name="City"
                rules=""
              >
                <v-select
                  v-model="driverInfo.city"
                  placeholder="City"
                  :options="cityOptions"
                />
                <!-- <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <v-select
                    v-model="driverInfo.city"
                    placeholder="City"
                    :options="cityOptions"
                  />
                </b-input-group> -->
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Street"
              label-for="street"
            >
              <validation-provider
                #default="{ errors }"
                name="Street"
                rules=""
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="street"
                    v-model="driverInfo.street"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Start Date"
              rules="required"
            >
              <b-form-group label="Birth Date">
                <b-form-datepicker
                  id="birthDate"
                  v-model="driverInfo.dateOfBirth"
                  show-decade-nav
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <!-- submit buttons -->
        <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          @click="validationForm"
        >
          Save
        </b-button>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BInputGroup,
  BButton,
  BFormDatepicker,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { pick } from 'lodash'
import { required, email } from '@validations'
import { reactive } from '@vue/composition-api'
import {
  max, alphaSpaces, maxCharacters,
} from '../../../utils/validations'
import ProfilePicture from './ProfilePicture.vue'
// import { isJordanianAdmin } from '@/utils/validate-admin-country'

export default {
  components: {
    vSelect,
    ProfilePicture,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormDatepicker,
    BFormInput,
    BFormRadioGroup,
    BInputGroup,
    BButton,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    driverData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const genderOptions = [
      { text: 'Male', value: 'MALE' },
      { text: 'Female', value: 'FEMALE' },
    ]

    let cityOptions
    const userData = JSON.parse(localStorage.getItem('userData'))
    const userCountry = userData?.country

    if (userCountry === undefined) {
      cityOptions = [
        'AMMAN',
        'ZARQA',
        'IRBD',
        'MAAN',
        'MADABA',
        'TAFILAH',
        'AQABA',
        'KARAK',
        'BALQA',
        'JARASH',
        'MAFRAQ',
        'AJLUN',
        'TRIPOLI',
        'BENGAZI',
      ]
    } else if (userCountry === 'JO') {
      cityOptions = [
        'AMMAN',
        'RAMTHA',
        'ZARQA',
        'IRBD',
        'MAAN',
        'MADABA',
        'TAFILAH',
        'AQABA',
        'KARAK',
        'BALQA',
        'JARASH',
        'MAFRAQ',
        'AJLUN',
      ]
    } else if (userCountry === 'LY') {
      cityOptions = [
        'TRIPOLI',
        'BENGAZI',
      ]
    }

    const driverInfo = reactive({ ...props.driverData })
    if (!driverInfo.gender) driverInfo.gender = 'MALE'

    return {
      genderOptions,
      required,
      email,
      max,
      alphaSpaces,
      maxCharacters,
      driverInfo,
      cityOptions,
    }
  },
  computed: {
    loggedUser() {
      return this.$store.getters['auth/getLoggedUser']
    },
  },
  methods: {
    validateName(e) {
      if (!/^[a-zA-Zء-ي\s-]*$/.test(e.key)) {
        e.preventDefault()
      }
    },
    async validationForm() {
      const isValid = await this.$refs.personalInfoValidation.validate()
      if (isValid) {
        const result = await this.$swal({
          title: 'Are you sure?',
          text: 'You want to apply this action?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, update it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
        if (result.value) {
          const driverData = { ...this.driverInfo }
          try {
            await this.$store.dispatch(
              'drivers/updateDriver',
              {
                id: this.driverInfo.id,
                addedByAdmin: this.loggedUser.email,
                data: pick(driverData, [
                  'firstName',
                  'lastName',
                  'email',
                  'nationalId',
                  'gender',
                  'street',
                  'dateOfBirth',
                  'city']),
              },
            )
            this.$emit('switch-to-services-tab', 1)
            this.$swal({
              icon: 'success',
              title: 'Saved',
              text: 'Information have been updated!',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          } catch (err) {
            let message = `${err}`
            const responseData = err.response && err.response.data ? err.response.data : {}
            if (responseData?.error?.national_id) { // national_id error
              [message] = responseData.error.national_id
            }
            if (responseData.error.city) {
              [message] = responseData.error.city
            }
            if (message) {
              this.$swal({
                icon: 'error',
                title: 'Error',
                text: `${message}`,
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            }
          }
        }
      }
    },
  },
}
</script>

<style lang="scss">
</style>
